import React from "react";

import { BoldText, MediumText, RegularText } from "components/Text";
import { VerticalSpace } from "components/Spacing";

import { mainLogo } from "utils/assets";

import styles from "./styles.module.scss";

/** Главный экран — логотип и приветствие */
export const HomePage = () => (
  <div className={styles.page}>
    <div className={styles.hero}>
      <img src={mainLogo} alt="Florapoint" className={styles.logo} />
      <VerticalSpace size={28} />
      <BoldText size={28} className={styles.title}>
        Florapoint
      </BoldText>
      <VerticalSpace size={10} />
      <MediumText size={16} color="muted" className={styles.subtitle}>
        Система учёта для цветочного бизнеса
      </MediumText>
      <VerticalSpace size={24} />
      <RegularText size={14} color="muted" className={styles.hint}>
        Выберите раздел в меню слева: справочники, маркетинг, документы или отчёты
      </RegularText>
    </div>
  </div>
);
